import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
///import { FarmacoComponent } from './features/dashboard/pages/farmaco/farmaco.component';

export const routes: Routes = [
  //{ path: 'farmaco', component: FarmacoComponent}
  {
    path: 'login',
    loadComponent: () =>
      import('./core/auth/auth-main/auth-main.component').then((m) => m.AuthMainComponent),
  },
  {
    path: 'login/:company', loadComponent: () =>
      import('./core/auth/auth-main/auth-main.component').then((m) => m.AuthMainComponent)
  },
  {
    path: 'logout-callback', loadComponent: () =>
      import('./core/auth/logout-callback/logout-callback.component').then((m) => m.LogoutCallbackComponent)
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () => import('./features/layout/layout-main/layout-main.component').then((m) => m.LayoutMainComponent),
    children: [
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/home/home.component').then((m) => m.HomeComponent),
      },
    {
  path: 'territorial/farmaco',
  canActivate: [AuthGuard],
  loadComponent: () =>
    import('./features/dashboard/pages/farmaco/farmaco.component').then((m) => m.FarmacoComponent),
  children: [
    {
      path: '',
      redirectTo: 'prodotti',
      pathMatch: 'full'
    },
    {
      path: 'prodotti',
      canActivate: [AuthGuard],
      loadComponent: () =>
        import('./features/dashboard/pages/farmaco/products/products.component').then((m) => m.ProductsComponent)
    },
    {
      path: 'benchmark',
      canActivate: [AuthGuard],
      loadComponent: () =>
        import('./features/dashboard/pages/farmaco/benchmark/benchmark.component').then((m) => m.BenchmarkComponent)
    },
  ]
},
      {
        path: 'territorial/national/:id',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/pages/national/national.component').then((m) => m.NationalComponent)
      },
      {
        path: 'territorial/overview/:id',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/pages/overview/overview.component').then((m) => m.OverviewComponent)
      },
      {
        path: 'profile',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/profile/profile.component').then((m) => m.ProfileComponent)
      },
      {
        path: 'profile/team-member-performance',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/profile/components/team-member-performance/team-member-performance.component').then((m) => m.TeamMemberPerformanceComponent)
      },
      /* {
        path: 'settings',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/pages/settings/settings.component').then((m) => m.SettingsComponent)
      },*/
      {
        path: 'territorial/regional/:medicineId/:regionId',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/dashboard/pages/regional/regional.component').then(m => m.RegionalComponent),
        children: [
          {
            path: 'info',
            canActivate: [AuthGuard],
            loadComponent: () =>
              import('./features/dashboard/pages/regional/pages/info-regional/info-regional.component').then(m => m.InfoRegionalComponent)
          },
          {
            path: 'inclusion-process',
            canActivate: [AuthGuard],
            loadComponent: () =>
              import('./features/dashboard/pages/regional/pages/inclusion-process-regional/inclusion-process-regional.component').then(m => m.InclusionProcessRegionalComponent)
          },
          {
            path: 'access-plan',
            canActivate: [AuthGuard],
            loadComponent: () =>
              import('./features/dashboard/pages/regional/pages/access-plan-regional/access-plan-regional.component').then(m => m.AccessPlanRegionalComponent)
          },
          {
            path: 'regional-dashboard',
            canActivate: [AuthGuard],
            loadComponent: () =>
              import('./features/dashboard/pages/regional/pages/regional-dashboard/regional-dashboard.component').then(m => m.RegionalDashboardComponent)
          },
          {
            path: '',
            redirectTo: 'info',  // default tab
            pathMatch: 'full'
          }
        ]
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home'
      }
    ]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
